import '../assets/style/index.styl'

import mSearch from './module/search.vue'
import mOperate from './module/operate.vue'

import cTable from './table/index.vue'
import cTableColumn from './table/column.vue'
import cTableButton from './table/button.vue'

import cForm from './form/index.vue'
import cFormColumn from './form/column.vue'
import cFormItem from './form/item.vue'

import cDetail from './detail/index.vue'
import cDetailItem from './detail/item.vue'

import cInput from './unit/input.vue'
import cButton from './unit/button.vue'
import cRadio from './unit/radio.vue'
import cRadioGroup from './unit/radio_group.vue'
import cCheckbox from './unit/checkbox.vue'
import cCheckboxGroup from './unit/checkbox_group.vue'
import cSelect from './unit/select.vue'
import cDatetime from './unit/datetime.vue'
import cColor from './unit/color.vue'
import cLink from './unit/link.vue'
import cMedia from './unit/media.vue'
import cFile from './unit/file.vue'
import cEditor from './unit/editor.vue'
import cImage from './unit/image.vue'
import cSwitch from './unit/switch.vue'

import cDialog from './dialog/index.vue'

import ossSelector from '../oss_manage/selector.vue'
import linkSelector from '../decorate_manage/link_selector.vue'

// 挂载动态组件
import dynamicComp from './dynamic';

import shortcuts from '../assets/script/shortcuts.js';

const COMPS_VM = {};

const CREATE_COMP = (Vue, name, comp) => {
	if (!COMPS_VM[name]) {
		let constructor = Vue.extend(comp);
		COMPS_VM[name] = new constructor({
			el: document.createElement('div'),
			beforeDestroy() {
				delete COMPS_VM[name];
				this.$el.remove();
			}
		});
		document.body.appendChild(COMPS_VM[name].$el);
	}
	
	return COMPS_VM[name];
}

// 导出组件
export default {
	install: function(Vue, config) {
		Vue.prototype.sub = {
			oms: !!config.oms,
			saas: !!config.saas,
			
			decorate: config.decorate || {},
			
			parsePixel(size) {
				if (parseInt(size) == size) {
					return parseInt(size) + 'px';
				}
				return size;
			},
			
			parseFile(url = '') {
				let name = '', suffix = '', base64 = false;
				if (url) {
					url = url.split('?')[0];
					base64 = /^data:.*;base64,/.test(url);
					if (base64) {
						let match = url.match(/^data:([a-z]*)\/(.*);base64,/);
						name = url;
						suffix = match[2];
					} else {
						suffix = url.match(/\.([^\/\.]*)$/);
						suffix = suffix ? suffix[1] : '';
						name = url.match(suffix ? /([^\/]*)\.[^\/\.]*$/ : /([^\/]*)$/)[1];
					}
				}
				
				let media = false;
				if (/(png|jpg|jpe?g|gif)$/i.test(suffix)) {
					media = 'image';
				} else if (/(mp4)$/i.test(suffix)) {
					media = 'video';
				}
				name = decodeURIComponent(name);
				
				return {
					name,
					suffix: suffix.toLocaleLowerCase(),
					encodeSrc: base64 ? url : url.replaceAll(name, encodeURIComponent(name)),
					media,
					base64
				}
			},
			
			parseLink(link) {
				if (link && link.includes('#link#')) {
					var data = link.split('#link#');
					var type = {
							'0': '系统页',
							'5': '装修页',
							'7': '服务列表',
							'8': data[1].includes('point') ? '积分服务' : '服务',
							'1': '公众号文章'
						};
					
					return `[${type[data[0]]}] ${data[2] || data[1]}`;
				}
				
				return '';
			},
			
			$upload(opt) {
				config.$upload(opt);
			}
		}
		
		Vue.prototype.$shortcuts = shortcuts;
		
		Vue.use(dynamicComp);
		
		Vue.prototype.$selectFile = opt => {
			CREATE_COMP(Vue, 'ossSelector', ossSelector).config(Object.assign({
				type: 'image',
				count: 1,
				size: '',
				resolve: function() {}
			}, opt || {}));
		}
		
		Vue.prototype.$selectLink = (value, opt) => {
			opt.type = opt.type == 'pc' ? 1 : 2;
			CREATE_COMP(Vue, 'linkSelector', linkSelector).config(value, Object.assign({
				resolve: function() {}
			}, opt || {}));
		}
		
		Vue.prototype.resetSubmodule = () => {
			['ossSelector', 'linkSelector'].forEach(name => {
				if (COMPS_VM[name]) {
					COMPS_VM[name].$destroy();
					delete COMPS_VM[name];
				}
			});
		}
		
		Vue.component('subSearch', mSearch);
		Vue.component('subOperate', mOperate);
		
		Vue.component('subInput', cInput);
		Vue.component('subButton', cButton);
		Vue.component('subRadio', cRadio);
		Vue.component('subRadioGroup', cRadioGroup);
		Vue.component('subCheckbox', cCheckbox);
		Vue.component('subCheckboxGroup', cCheckboxGroup);
		Vue.component('subSelect', cSelect);
		Vue.component('subDatetime', cDatetime);
		Vue.component('subColor', cColor);
		Vue.component('subLink', cLink);
		Vue.component('subMedia', cMedia);
		Vue.component('subFile', cFile);
		Vue.component('subEditor', cEditor);
		Vue.component('subImage', cImage);
		Vue.component('subSwitch', cSwitch);
		
		Vue.component('subTable', cTable);
		Vue.component('subTableColumn', cTableColumn);
		Vue.component('subTableButton', cTableButton);
		
		Vue.component('subForm', cForm);
		Vue.component('subFormColumn', cFormColumn);
		Vue.component('subFormItem', cFormItem);
		
		Vue.component('subDetail', cDetail);
		Vue.component('subDetailItem', cDetailItem);
		
		Vue.component('subDialog', cDialog);
    }
}